var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 264,
    height: 119.875,
    viewBox: "0 0 264 119.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-1050.5 -2029)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "monitor",
    transform: "translate(1182.5 2125)",
    fill: "#308275",
    fontSize: 77,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -131.478,
    y: 0
  }, "MONITOR")), /*#__PURE__*/React.createElement("text", {
    id: "_7_out_of_10_domestic_abusers",
    "data-name": "7 out of 10 domestic abusers",
    transform: "translate(1182.5 2053)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -118.67,
    y: 0
  }, "7 OUT OF 10 DOMESTIC ABUSERS")), /*#__PURE__*/React.createElement("text", {
    id: "their_victims_devices",
    "data-name": "their victims\\u2019 devices",
    transform: "translate(1182.5 2145.875)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -72.648,
    y: 0
  }, "their victims\u2019 devices")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD4);
export default __webpack_public_path__ + "static/media/d4.300af85c2b6887eb2f674d34651240bd.svg";
export { ForwardRef as ReactComponent };